export default __webpack_public_path__ + "static/media/rectangle-3-breaks.cf6ee0d3.webp";